// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._8dCElfqouj6woc {\n  display: block;\n  text-align: center;\n}\n._8dCElfqouj6woc h4 {\n  font-size: 20px;\n  margin: 20px 16px 24px;\n}\n._8dCElfqouj6woc p {\n  font-size: 16px;\n  margin: 0 0 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": "_8dCElfqouj6woc"
};
export default ___CSS_LOADER_EXPORT___;
